<template>
  <div>
    <md-content class="md-scrollbar" style="background: #fafafa;">
      <md-list class="md-triple-line" v-for="t in test" :key=t.number style="width: 485px">
        <md-list-item @click="moreInfo(t)">
          <div class="md-list-item-text">
            <span>{{ t.city }}</span>
            <span>{{ t.message }}</span>
            <p>{{ t.date }}</p>
            <!-- <hr> -->
          </div>
        </md-list-item>  
      </md-list>
      <md-button class="md-raised">Load More</md-button>
    </md-content>

    <md-dialog :md-active.sync="showDialog" >
      <md-dialog-title>Batch Information</md-dialog-title>

      <md-tabs md-dynamic-height >
        <md-tab md-label="Message">
          <p style="text-align: left">{{ selected.message }}</p>
        </md-tab>

        <md-tab md-label="Phone Numbers">
          <md-list v-for="n in selected.numbers" :key=n>
            <md-list-item>
              <span class="md-list-item-text">{{ n }}</span>
            </md-list-item>  
          </md-list>
        </md-tab>
      </md-tabs>

      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>
    
  </div>
</template>

<script>
export default {
  data: () => ({
    showDialog: false,
    selected: {},
    test: [
      {
        city: 'Austin',
        message: 'You’re scheduled to participate in a MediaScience study TODAY! Please arrive 10 min prior to your appointment. There is no grace period for late arrivals. CALL IN if you need to cancel your appointment. 512-837-5646',
        date: '2/4/2019',
        numbers: ['5129405509', '5129405509', '5129405509', '5129405509'],
      },
      {
        city: 'Chicago',
        message: 'You’re scheduled to participate in a MediaScience study TODAY! Please arrive 10 min prior to your appointment. There is no grace period for late arrivals. CALL IN if you need to cancel your appointment. 512-837-5646',
        date: '2/4/2019',
        numbers: ['5129405509', '5129405509', '5129405509', '5129405509'],
      },
      {
        city: 'New York',
        message: 'You’re scheduled to participate in a MediaScience study TODAY! Please arrive 10 min prior to your appointment. There is no grace period for late arrivals. CALL IN if you need to cancel your appointment. 512-837-5646',
        date: '2/4/2019',
        numbers: ['5129405509', '5129405509', '5129405509', '5129405509'],
      },
      {
        city: 'Austin',
        message: 'You’re scheduled to participate in a MediaScience study TODAY! Please arrive 10 min prior to your appointment. There is no grace period for late arrivals. CALL IN if you need to cancel your appointment. 512-837-5646',
        date: '2/4/2019',
        numbers: ['5129405509', '5129405509', '5129405509', '5129405509'],
      },
      {
        city: 'Chicago',
        message: 'You’re scheduled to participate in a MediaScience study TODAY! Please arrive 10 min prior to your appointment. There is no grace period for late arrivals. CALL IN if you need to cancel your appointment. 512-837-5646',
        date: '2/4/2019',
        numbers: ['5129405509', '5129405509', '5129405509', '5129405509'],
      },
      {
        city: 'New York',
        message: 'You’re scheduled to participate in a MediaScience study TODAY! Please arrive 10 min prior to your appointment. There is no grace period for late arrivals. CALL IN if you need to cancel your appointment. 512-837-5646',
        date: '2/4/2019',
        numbers: ['5129405509', '5129405509', '5129405509', '5129405509'],
      }
    ],
    startDate: '',
  }),
  methods: {
    moreInfo (batch) {
      this.selected = batch
      this.showDialog = true
    }
  }
}
</script>

<style scoped>
.p {
  text-align: left;
}
.md-list {
  background: #fafafa !important;
}
.md-list-item {
  box-shadow: inset 0 0 0 1px gray;
  border-radius: 3px;
}
.md-content {
  max-height: 416px;
  overflow: auto;
}
</style>

